import { makeTypedFetchSelectors } from 'app/redux-fetch'
import {
  DEPLOY_DOMAIN_CONFIG_REDUCER_NAME,
  HOME_REDUCER_NAME,
} from 'features/home/consts'

export const deployDomainConfigSelectors = makeTypedFetchSelectors(
  HOME_REDUCER_NAME,
  DEPLOY_DOMAIN_CONFIG_REDUCER_NAME
)
